import _ from '../helper/HelperFunctions';

export default class GenreTitles {
	constructor(relatedModule) {
		this.parent = relatedModule;
		this.buttons = _.toArray(this.parent.getElementsByTagName('button'));

		this._setListeners();
	}

	_setListeners() {
		this.buttons.forEach(button => {
			button.addEventListener(_.clickEvent(), e => {
				const container = this.parent.querySelector(`.title-wrapper[data-genre="${e.currentTarget.getAttribute('data-genre')}"]`)
				_.removeClassFromAll(_.toArray(this.parent.querySelectorAll('.title-wrapper')), 'active', container, true);
				_.removeClassFromAll(this.buttons, 'active', e.currentTarget, true);

				// -- Recalculate carousel state
				container.dispatchEvent( new Event('recalculate') )
			})
		})
	}
}